import { makeStyles } from '@material-ui/core'

import colors from '@galo-monitor/styles/colors'

export default makeStyles(() => ({
  noPadding: {
    padding: 0
  },
  item: {
    '& > *': {
      '& span': {
        fontSize: '0.9rem !important'
      }
    }
  },
  loadingItems: {
    opacity: 0.8
  },
  loader: {
    position: 'absolute',
    marginTop: '0px !important'
  },
  actions: {
    top: '50%',
    right: 5,
    position: 'absolute',
    transform: 'translateY(-50%)'
  },
  actionItem: {
    '&:hover': {
      '& > *': {
        color: `${ colors.primary } !important`
      }
    }
  }
}))